import { render, staticRenderFns } from "./GroupLegendIndexOfTheResult.vue?vue&type=template&id=1ed8bb8e&scoped=true"
import script from "./GroupLegendIndexOfTheResult.vue?vue&type=script&lang=js"
export * from "./GroupLegendIndexOfTheResult.vue?vue&type=script&lang=js"
import style0 from "./GroupLegendIndexOfTheResult.vue?vue&type=style&index=0&id=1ed8bb8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8bb8e",
  null
  
)

export default component.exports